module.exports = __webpack_public_path__ + "img/1.de7d457d.png";